export const USER_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  UNCONFIRMED: 'unconfirmed',
};
